import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallNodePackageManagers from "../install-node-package-managers.mdx";
import Tab from "components/Tab";
import AppRouterServerSetup from "./app-router-server-setup.mdx";
import PagesRouterServerSetup from "./pages-router-server-setup.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Next.js enables you to both server-side render pages and add server-side functionality. To integrate PostHog into your Next.js app on the server-side, you can use the `}<a parentName="p" {...{
        "href": "/docs/libraries/node"
      }}>{`Node SDK`}</a>{`.`}</p>
    <p>{`First, install the `}<inlineCode parentName="p">{`posthog-node`}</inlineCode>{` library:`}</p>

    <InstallNodePackageManagers mdxType="InstallNodePackageManagers" />
    <h3 {...{
      "id": "router-specific-instructions"
    }}>{`Router-specific instructions`}</h3>

    <Tab.Group tabs={['App router', 'Pages router']}>
    <Tab.List>
        <Tab mdxType="Tab">App router</Tab>
        <Tab mdxType="Tab">Pages router</Tab>
    </Tab.List>
    <Tab.Panels>
        <Tab.Panel>
            <AppRouterServerSetup mdxType="AppRouterServerSetup" />
        </Tab.Panel>
        <Tab.Panel>
            <PagesRouterServerSetup mdxType="PagesRouterServerSetup" />
        </Tab.Panel>
    </Tab.Panels>
    </Tab.Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      